import { reducer, union } from "ts-action";
import { on } from "ts-action-immer";
import * as AC from "../actionCreators";
import forDatasourceIdReducer, {
  ForDatasourceIdState,
} from "./forDatasourceId";

export type State = Record<number, ForDatasourceIdState | undefined>;

const initialState: State = {};

const byDatasourceIdReducer = reducer(
  initialState,
  on(...union(...Object.values(AC)), (state, action) => {
    const { datasourceId } = action.payload;
    state[datasourceId] = forDatasourceIdReducer(state[datasourceId], action);
  })
  // Casem se to rozvetvi pro bulk cases
);

export default byDatasourceIdReducer;
export type ByDatasourceIdState = State;
